import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
import { initialFromDate } from '@/utils/utils';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  userDNDs: [],
  totalPages: 0,
  totalRecords: 0,
  errorStatus: null,
};
const getters = {
  getApiLoad_105: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_userDNDs(state, userDNDs) {
    state.userDNDs = userDNDs.items;
    state.totalPages = userDNDs.totalPages;
    state.totalRecords = userDNDs?.totalRecords ?? 0;
  },
};
const actions = {
  errorUserDND({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getUserDNDsWithPagination(
    { commit, dispatch, rootState },
    { fromDate, toDate, userId, pageNumber, pageSize },
  ) {
    var url = '/userDNDs/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    // if (fromDate) {
    url += '&FromDate=' + initialFromDate(fromDate);
    // }
    if (toDate) {
      url += '&ToDate=' + toDate;
    }
    if (userId) {
      url += '&UserId=' + userId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_userDNDs', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserDND', error);
      });
  },
  enableUserDND({ commit, dispatch, rootState }) {
    return apiClient
      .post('/userDNDs/Enable', {}, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserDND', error);
      });
  },
  disableUserDND({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/userDNDs/Disable', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorUserDND', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
